export enum SegmentSource {
    STANDARD = 'standard',
    INLINE = 'inline',
    ADHOC = 'adhoc',
    API_INLINE = 'api-inline',
}
